export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 财务中心-我的发票
  {
    path: 'invoiceList',
    name: 'invoiceList',
    meta: {
      title: '我的发票'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/invoiceList');
    }
  }, {
    path: 'newInvoice',
    name: 'newInvoice',
    meta: {
      title: '申请开票'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/newInvoice');
    }
  }, // 支付对账-销项发票管理
  {
    path: 'newLcpInvoiceList',
    name: 'newLcpInvoiceList',
    meta: {
      title: '发票管理'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/newLcpInvoiceList');
    }
  }, // 支付对账-红冲发票
  {
    path: 'redInvoiceList',
    name: 'redInvoiceList',
    meta: {
      title: '红冲发票'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/redInvoiceList');
    }
  }, // 支付对账-红冲发票-红冲申请查看
  {
    path: 'redInvoiceDetail',
    name: 'redInvoiceDetail',
    meta: {
      title: '红冲申请查看'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/redInvoiceDetail');
    }
  }, // 支付对账-销项发票管理-修改
  {
    path: 'lcpFinMatchingBillEdit',
    name: 'lcpFinMatchingBillEdit',
    meta: {
      title: '修改发票信息'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/lcpFinMatchingBillEdit');
    }
  }, // 支付对账-销项发票管理-修改（部分已开票）
  {
    path: 'lcpFinMatchingBillErrEdit',
    name: 'lcpFinMatchingBillErrEdit',
    meta: {
      title: '修改发票信息'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/lcpFinMatchingBillErrEdit');
    }
  }, // 支付对账-销项发票管理-详情
  {
    path: 'lcpFinMatchingBillDetail',
    name: 'lcpFinMatchingBillDetail',
    meta: {
      title: '发票信息详情'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/lcpFinMatchingBillDetail');
    }
  }, // 采购侧-发票详情
  {
    path: 'newLcpFinMatchingBillDetail',
    name: 'newLcpFinMatchingBillDetail',
    meta: {
      title: '发票信息详情'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/newLcpFinMatchingBillDetail');
    }
  }, // 采购侧-发票详情
  {
    path: 'batchLcpInvoice',
    name: 'batchLcpInvoice',
    meta: {
      title: '批量新增开票申请'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/batchLcpInvoice');
    }
  }, // 支付对账-销项发票管理-失败原因查看列表
  {
    path: 'invFailList',
    name: 'invFailList',
    meta: {
      title: '开票失败原因查看列表'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/invFailList');
    }
  }, // 支付对账-销项发票管理-上传发票
  {
    path: 'newUnagrimportInvInformation',
    name: 'newUnagrimportInvInformation',
    meta: {
      title: '上传发票'
    },
    component: function component() {
      return import('@/pages/accountCenter/invoiceMenu/newUnagrimportInvInformation');
    }
  }, // 财务中心-可开票/不可开票
  {
    path: 'lcpFinMatchingBillList',
    name: 'lcpFinMatchingBillList',
    meta: {
      title: '可开票列表'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpFinMatchingBillList/lcpFinMatchingBillList');
    }
  }, // 财务中心-可开票-申请开票
  {
    path: 'lcpFinMatchingBill',
    name: 'lcpFinMatchingBill',
    meta: {
      title: '申请开票'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpFinMatchingBillList/lcpFinMatchingBill');
    }
  }, // 修改开票
  {
    path: 'editLcpFinMatchingBill',
    name: 'editLcpFinMatchingBill',
    meta: {
      title: '申请开票'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpFinMatchingBillList/editLcpFinMatchingBill');
    }
  }, // 财务中心-可开票-申请开票(运营侧)
  {
    path: 'newLcpFinMatchingBill',
    name: 'newLcpFinMatchingBill',
    meta: {
      title: '申请开票'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpFinMatchingBillList/newLcpFinMatchingBill');
    }
  }, // 账号中心-发票信息管理/发票接收地址管理
  {
    path: 'lcpInvoiceInfoAddrManage',
    name: 'lcpInvoiceInfoAddrManage',
    meta: {
      title: '发票信息管理'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoAddrManage');
    }
  }, // 账号中心-发票信息管理-发票信息详情
  {
    path: 'lcpInvoiceInfoDetail',
    name: 'lcpInvoiceInfoDetail',
    meta: {
      title: '发票信息详情'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoDetail');
    }
  }, // 账号中心-发票信息管理-新增发票信息
  {
    path: 'lcpInvoiceInfoAdd',
    name: 'lcpInvoiceInfoAdd',
    meta: {
      title: '新增发票信息'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoAdd');
    }
  }, // 账号中心-发票信息管理-修改发票信息
  {
    path: 'lcpInvoiceInfoEdit',
    name: 'lcpInvoiceInfoEdit',
    meta: {
      title: '修改发票信息'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoEdit');
    }
  }, // 账号中心-发票接收地址管理-发票接收地址详情页
  {
    path: 'lcpInvoiceInfoAddrDetail',
    name: 'lcpInvoiceInfoAddrDetail',
    meta: {
      title: '发票接收地址详情页'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoAddrDetail');
    }
  }, // 账号中心-发票接收地址管理-新增发票接收地址
  {
    path: 'lcpInvoiceInfoAddrAdd',
    name: 'lcpInvoiceInfoAddrAdd',
    meta: {
      title: '新增发票接收地址'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoAddrAdd');
    }
  }, // 账号中心-发票接收地址管理-新增发票接收地址
  {
    path: 'lcpInvoiceInfoAddrEdit',
    name: 'lcpInvoiceInfoAddrEdit',
    meta: {
      title: '修改发票接收地址'
    },
    component: function component() {
      return import('@/pages/accountCenter/lcpInvoiceInfoAddrManage/lcpInvoiceInfoAddrEdit');
    }
  }, {
    path: 'companyEntityList',
    name: 'companyEntityList',
    meta: {
      title: '诚富亦开票管理'
    },
    component: function component() {
      return import('@/pages/accountCenter/companyEntityInv/companyEntityList');
    }
  }, {
    path: 'companyEntityInvDetail',
    name: 'companyEntityInvDetail',
    meta: {
      title: '诚富亦对账单详情'
    },
    component: function component() {
      return import('@/pages/accountCenter/companyEntityInv/companyEntityInvDetail');
    }
  }, {
    path: 'comDownFscorder',
    name: 'comDownFscorder',
    meta: {
      title: '诚富亦下载对账单'
    },
    component: function component() {
      return import('@/pages/accountCenter/companyEntityInv/comDownFscorder');
    }
  }]
};